import { render } from "./ProductFamily.vue?vue&type=template&id=1f17f8a9&ts=true"
import script from "./ProductFamily.vue?vue&type=script&lang=ts"
export * from "./ProductFamily.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__